import { Card, CardContent } from "@shared/ui/card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { ArrowDown, ArrowUp, Info } from "lucide-react";
import { QuickStatsCardProps } from "../types/quickStatsCardProps";
import { HelpCircle } from "lucide-react"

export function QuickStatsCard({
  title,
  count,
  displayValue,
  trend,
  trendDurationDisplay,
  trendSummary,
  icon,
  tooltip,
}: QuickStatsCardProps) {
  const trendDirectionStat = trend > 0 ? "up" : trend < 0 ? "down" : "neutral";
  const trendDurationDisplayText = trendDurationDisplay
    ? trendDurationDisplay
    : "from yesterday";
  return (
    <Card>
      <CardContent className="pt-0">
        <div className="flex justify-between">
          <div>
            <div className="flex items-center gap-1">
              <p className="text-sm font-medium text-muted-foreground">
                {title}
              </p>
              {tooltip && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <HelpCircle className="w-4 h-4 text-gray-400 hover:text-gray-600" />
                    </TooltipTrigger>
                    <TooltipContent>{tooltip}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
            <p className="text-lg font-bold mt-1">{displayValue || count}</p>
            <div className="flex items-center mt-1">
              {typeof trend === "number" ? (
                trendDirectionStat !== "neutral" ? (
                  <span
                    className={`flex items-center text-xs ${
                      trendDirectionStat === "up"
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {trendDirectionStat === "up" ? (
                      <ArrowUp className="h-3 w-3 mr-1" />
                    ) : (
                      <ArrowDown className="h-3 w-3 mr-1" />
                    )}
                    {trend}% {trendDurationDisplayText}
                  </span>
                ) : (
                  <span className="text-xs text-muted-foreground">
                    0 {trendDurationDisplayText}
                  </span>
                )
              ) : (
                <span className="text-xs text-muted-foreground">
                  {trendSummary}
                </span>
              )}
            </div>
          </div>
          <div className="w-12 h-12 rounded-lg flex items-center justify-center">
            <div>{icon}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}